import { createContext } from "react";
export const UIContext = createContext({})

// state set up for ui context in pages.